import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOnlineCategories, fetchOnlineWebsitesByCategory } from '../../services/onlineWebsiteService';

// 异步thunk - 获取在线网站数据
export const fetchOnlineWebsites = createAsyncThunk(
  'onlineWebsites/fetchOnlineWebsites',
  async (category, { rejectWithValue }) => {
    try {
      const websites = await fetchOnlineWebsitesByCategory(category);
      return { category, websites };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// 异步thunk - 重试获取数据
export const retryFetchOnlineWebsites = createAsyncThunk(
  'onlineWebsites/retryFetchOnlineWebsites',
  async (category, { rejectWithValue }) => {
    try {
      const websites = await fetchOnlineWebsitesByCategory(category);
      return { category, websites };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// 异步thunk - 获取分类列表
export const fetchCategories = createAsyncThunk(
  'onlineWebsites/fetchCategories',
  async (_, { rejectWithValue }) => {
    try {
      const categories = await fetchOnlineCategories();
      return categories;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const onlineWebsitesSlice = createSlice({
  name: 'onlineWebsites',
  initialState: {
    websites: [],
    loading: false,
    error: null,
    currentCategory: null, // 初始为null，等待分类数据加载后设置
    cache: {}, // 缓存不同分类的数据
    categories: [], // 分类数据
    categoriesLoading: false,
    categoriesError: null
  },
  reducers: {
    resetOnlineWebsitesError: (state) => {
      state.error = null;
    },
    clearOnlineWebsitesCache: (state) => {
      state.cache = {};
    },
    setCurrentCategory: (state, action) => {
      state.currentCategory = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // 处理 fetchOnlineWebsites
      .addCase(fetchOnlineWebsites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOnlineWebsites.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        const { category, websites } = action.payload;
        state.websites = websites;
        state.currentCategory = category;
        // 缓存数据
        state.cache[category] = websites;
      })
      .addCase(fetchOnlineWebsites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 处理 retryFetchOnlineWebsites
      .addCase(retryFetchOnlineWebsites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(retryFetchOnlineWebsites.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        const { category, websites } = action.payload;
        state.websites = websites;
        state.currentCategory = category;
        // 更新缓存
        state.cache[category] = websites;
      })
      .addCase(retryFetchOnlineWebsites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 处理 fetchCategories
      .addCase(fetchCategories.pending, (state) => {
        state.categoriesLoading = true;
        state.categoriesError = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.categoriesLoading = false;
        state.categoriesError = null;
        state.categories = action.payload;
        // 如果当前没有选中分类，且有分类数据，则跳过第一个分类（全部分类），选择第二个分类作为默认
        if (!state.currentCategory && action.payload.length > 0) {
          const defaultCategoryIndex = action.payload.length > 1 ? 1 : 0;
          state.currentCategory = action.payload[defaultCategoryIndex].id;
        }
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.categoriesLoading = false;
        state.categoriesError = action.payload;
      });
  }
});

export const { 
  resetOnlineWebsitesError, 
  clearOnlineWebsitesCache,
  setCurrentCategory 
} = onlineWebsitesSlice.actions;

export default onlineWebsitesSlice.reducer; 